export default __webpack_public_path__ + "static/media/15.4021ee90.jpg";